import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import ClientOnboarding from "../Auth/ClientOnboardingForm";

const RequireOnboarding = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [onboardingComplete, setOnboardingComplete] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      setOnboardingComplete(false);
      setLoading(false);
      return;
    }
    const userRef = doc(db, "users", user.uid);
    getDoc(userRef).then((docSnap) => {
      if (docSnap.exists()) {
        setOnboardingComplete(!!docSnap.data().onboardingStatus?.completed);
      } else {
        setOnboardingComplete(false);
      }
      setLoading(false);
    });
  }, []);

  if (loading) return <div>Loading...</div>;
  
  if (!onboardingComplete) {
    return <ClientOnboarding onComplete={() => setOnboardingComplete(true)} />;
  }
  
  return children;
};

export default RequireOnboarding; 